import modeEnum from "Areas/Documents/documentEditorPanel/mode";
import actionTypes from "./actionTypes";
import api from "./api";
import { saveFileBlobResponse } from "Common/fileUtils/fileSave";
import { error, success } from "App/popupMessage";
import locale from "./actionCreators.locale";
export default {
    closeForm: () => ({
        type: actionTypes.SET_MODE_AND_DOCUMENT_ID,
        folderId: undefined
    }),
    setCreateNewFolder: (documentId) => ({
        type: actionTypes.SET_MODE_AND_DOCUMENT_ID,
        mode: modeEnum.CREATE,
        documentId
    }),
    setEditFolder: (folderId) => ({
        type: actionTypes.SET_MODE_AND_DOCUMENT_ID,
        folderId,
        mode: modeEnum.EDIT
    }),
    getFolders: (documentId) => ({
        type: actionTypes.GET_FOLDERS,
        payload: {
            promise: () => api.getFolders(documentId)
        },
        meta: { documentId },
        scope: `${actionTypes.GET_FOLDERS}_${documentId}`
    }),
    deleteFolder: (folderId, documentId) => ({
        type: actionTypes.DELETE_FOLDER,
        payload: {
            promise: () => api.deleteFolder(folderId)
        },
        meta: { folderId, documentId },
        scope: `${actionTypes.DELETE_FOLDER}_${documentId}_${folderId}`
    }),
    deleteFile: (fileId, folderId, documentId) => ({
        type: actionTypes.DELETE_FILE,
        payload: {
            promise: () => api.deleteFile(fileId)
        },
        meta: { fileId, folderId },
        scope: `${actionTypes.DELETE_FILE}_${documentId}_${fileId}`
    }),
    getFiles: (folderId, documentId) => ({
        type: actionTypes.GET_FILES,
        payload: {
            promise: () => api.getFiles(folderId)
        },
        meta: { folderId, documentId },
        scope: `${actionTypes.GET_FILES}_${documentId}_${folderId}`
    }),
    saveFolder: (folder, files, completed) => ({
        type: actionTypes.SAVE_FOLDER,
        payload: {
            promise: () => api.saveFolder(folder, files)
        },
        meta: { folder, files },
        scope: `${actionTypes.SAVE_FOLDER}_${folder.DocumentId}_${folder.Id}`,
        completed
    }),
    setFolderId: (selectedFolderId, documentId) => ({
        type: actionTypes.SET_SELECTED_FOLDER,
        selectedFolderId,
        documentId
    }),
    setFileId: (selectedFolderId, documentId, fileId) => ({
        type: actionTypes.SET_SELECTED_FILE,
        selectedFolderId,
        documentId,
        fileId
    }),
    downloadFile: (fileId) => ({
        type: actionTypes.DOWNLOAD_DOCUMENTS,
        payload: {
            promise: () => api.downloadFile(fileId).then(response => saveFileBlobResponse({ response }))
        },
        scope: `${actionTypes.DOWNLOAD_DOCUMENTS}_${fileId}`,
        completed: (dispatch) => {
            dispatch(success(locale.FILE_DOWNLOAD_SUCCESS()));
        },
        rejected: (dispatch, { payload }) => {
            dispatch(error(locale.FILE_DOWNLOAD_FAILED({ error: payload.message, filleName: payload.fileName })));
        }
    })
};
